import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import assetFrequencyService from "services/assetFrequencyService";

export const updateAssetFrequency = createAsyncThunk(
  "assetFrequency/updateAssetFrequency",
  async (data, { rejectWithValue }) => {
    try {
      const resp = await assetFrequencyService.upsertAssetFrequency(data);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  lastRequest: null,
  lastResponse: null,
  data: null,
  loading: false,
  successMessage: null,
  errorMessage: null,
};

const assetFrequencySlice = createSlice({
  name: "assetFrequency",
  initialState,
  reducers: {
    resetAssetFrequencyMessages: (state) => {
      state.successMessage = null;
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateAssetFrequency.pending, (state, action) => {
        state.loading = true;
        state.successMessage = null;
        state.errorMessage = null;
        state.lastRequest = action.meta?.arg ?? null;
      })
      .addCase(updateAssetFrequency.fulfilled, (state, action) => {
        state.loading = false;
        state.lastResponse = action.payload ?? null;
        state.data = action.payload?.data ?? action.payload ?? null;

        const ok =
          action.payload?.status === 200 ||
          action.payload?.status === 204 ||
          !!action.payload?.data;

        state.successMessage = ok
          ? "asset.frequency.updated.successfuly"
          : null;
        state.errorMessage = ok ? null : "error.somethingWentWrong";
      })
      .addCase(updateAssetFrequency.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage =
          action.payload?.response?.data?.error || "error.somethingWentWrong";
      });
  },
});

export const { resetAssetFrequencyMessages } = assetFrequencySlice.actions;
export default assetFrequencySlice.reducer;
